/**
 * Dynamically creates async handler to handle crud actions in coordination with
 * corresponding redux actions, data model configs, etc.
 * All crud actions are Promise based and observable from the location of dispatch.
 *
 * @param name
 * @param asyncReq
 * @param dispatcher
 * @param primaryKey
 * @returns {Function|*}
 */

const createDynamicHandler = (name, asyncReq, dispatcher, primaryKey = 'uuid') => {
    const placeholder = {
        [name](...args) {
            return (dispatch, getState) => {
                let state = getState();
                let sessionToken = state.user.session;
                if (sessionToken == null) {
                    return Promise.reject("Invalid Session");
                }
                return new Promise((resolve, reject) => {
                    asyncReq(sessionToken, ...args).then(response => {
                        dispatch(dispatcher('success')({response, primaryKey}));
                        resolve(true);
                    }).catch(err => {
                        let {message, stack, config} = err;
                        dispatch(dispatcher('failure')({primaryKey}));
                        reject({message, stack, config});
                    });
                });
            }
        }
    };
    return placeholder[name];
};

export default createDynamicHandler;